import { useCallback } from 'react';
import type {
  TemplateType
} from '@server/trading-templates/schemas/input.schema';
import type { SaveTradingTemplateFormState } from '../save-trading-template-form';
import { DraftFormState } from '@client/state/draft-form-state.hook';
import { useWindow } from '@client/window/window.hook';
import { buildTemplateConfig } from '../template-config.utils';
import { useTemplateSave } from '../template-save.hook';

export const useCreateTemplate = () => {
  const { closeWindow } = useWindow();
  const { saveTemplate } = useTemplateSave();

  const onSubmit = useCallback(
    (
      draftState: DraftFormState,
      templateType: TemplateType,
      timeframeIndex: number
    ) =>
      async (formState: SaveTradingTemplateFormState) => {
        try {
          const config = buildTemplateConfig(
            draftState,
            templateType,
            timeframeIndex
          );

          await saveTemplate({
            name: formState.name,
            isBundle: false,
            config
          });

          closeWindow('SaveTradingTemplateForm');
        } catch {
          // saveTemplate already handles notifications for persistence failures.
        }
      },
    [closeWindow, saveTemplate]
  );

  return { onSubmit };
};
